import { ErrorHandler, Inject, Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';

import { AviationEvent } from '../../shared/models/aviation-event.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { AviationEventsService } from '../../shared/services/aviation-events.service';


@Injectable({
  providedIn: 'root'
})
export class EventResolver implements Resolve<AviationEvent> {

  constructor(@Inject(DOCUMENT) private document: any,
              private _router: Router,
              private _aviationEventsService: AviationEventsService,
              private _errorHandler: ErrorHandler,
              private _toggleService: EditToggleService) { }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<AviationEvent> {
    try {
      const id = route.paramMap.get('id');
      const aviationEvent = await this._aviationEventsService.getAviationEventById(+id);
      this._toggleService.setState(false);
      if (aviationEvent) {
        return aviationEvent;
      }
      this._router.navigate(['/404']);
      return null;
    } catch (e) {
      this._errorHandler.handleError(e);
      this._router.navigate(['/500']);
    }
  }
}
